
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_qk1j1_cwvhd_141",
  "textarea": "awsui_textarea_qk1j1_cwvhd_145",
  "textarea-readonly": "awsui_textarea-readonly_qk1j1_cwvhd_198",
  "textarea-invalid": "awsui_textarea-invalid_qk1j1_cwvhd_240",
  "textarea-warning": "awsui_textarea-warning_qk1j1_cwvhd_249"
};
  